/**
 * Tạo file .ics cho một giải đấu và mở nó.
 *
 * Không có API web nào ghi thẳng vào lịch điện thoại; cách dùng được trên cả
 * iOS lẫn Android là tải một file .ics — hệ điều hành nhận ra và mở app Lịch để
 * người dùng xác nhận thêm sự kiện.
 */

/** .ics dùng UTC dạng basic, không dấu phân cách. */
const toIcsDate = (value: Date): string =>
  value.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");

/** Dấu phẩy, chấm phẩy và xuống dòng là ký tự điều khiển trong .ics. */
const escapeText = (value: string): string =>
  value.replace(/\\/g, "\\\\").replace(/;/g, "\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");

export interface CalendarEvent {
  id: string;
  title: string;
  start: Date;
  end: Date;
  location?: string | null;
  description?: string | null;
  url?: string | null;
}

export const buildIcs = (event: CalendarEvent): string => {
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Biadi//Lich giai dau//VI",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${event.id}@biadi.vn`,
    `DTSTAMP:${toIcsDate(new Date())}`,
    `DTSTART:${toIcsDate(event.start)}`,
    `DTEND:${toIcsDate(event.end)}`,
    `SUMMARY:${escapeText(event.title)}`,
  ];
  if (event.location) lines.push(`LOCATION:${escapeText(event.location)}`);
  if (event.description) lines.push(`DESCRIPTION:${escapeText(event.description)}`);
  if (event.url) lines.push(`URL:${event.url}`);
  // Nhắc trước một ngày — đặt lịch cho một giải còn xa mà không có nhắc thì
  // gần như chắc chắn quên.
  lines.push(
    "BEGIN:VALARM",
    "TRIGGER:-P1D",
    "ACTION:DISPLAY",
    `DESCRIPTION:${escapeText(event.title)}`,
    "END:VALARM",
    "END:VEVENT",
    "END:VCALENDAR"
  );

  return lines.join("\r\n");
};

export const addToCalendar = (event: CalendarEvent): void => {
  const blob = new Blob([buildIcs(event)], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${event.title.replace(/[^\p{L}\p{N}]+/gu, "-")}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Thu hồi ngay là Safari chưa kịp đọc blob; để một nhịp cho chắc.
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
};
